import React, { Component } from 'react';
import '../css/App.css';
import { withRouter } from 'react-router-dom';
import {Provider, connect} from "react-redux";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router} from "react-router-dom";
import { createBrowserHistory } from 'history';
import axios from "axios";

import HeaderContainer from "./header/HeaderContainer.js";
import FooterContainer from "./footer/FooterContainer.js";

import { mapStateToProps, mapDispatchToProps } from '../dispatchers.js';

import LandingPage from "./landingPage/landingPage.js";
import CharacterLayout from "./layouts/characterLayout.js";
import CharacterDatabaseLayout from "./layouts/characterDatabaseLayout.js";
import ComicDatabaseLayout from "./layouts/comicDatabaseLayout.js";
import ComicDetailLayout from "./layouts/comicDetailLayout.js";
import {getMainCharacterData} from "./includes/axios/getMainCharacterData.js";
import {getMainComic} from "./includes/axios/getMainComic.js";
import {getComicListData} from "./includes/axios/getComicListData.js";
import {getCharacterListData} from "./includes/axios/getCharacterListData.js";
import {getCharacterDatabaseData} from "./includes/axios/getCharacterDatabaseData.js";
import {getComicDatabaseData} from "./includes/axios/getComicDatabaseData.js";
import {getVideoListData} from "./includes/axios/getVideoListData.js";
import Pagination from "./pagination/Pagination.js";
import VideosPageLayout from "./layouts/videosPageLayout.js";
import VideoDetailLayout from "./layouts/videoDetailLayout.js";

import {routeRedirect} from "./includes/behindTheScenes/routeRedirect.js";


class App extends Component {
  
  constructor(props) {
    super(props);
    this.changeCharacter = this.props.changeCharacter;
    this.changeFeaturedComics = this.props.changeFeaturedComics;
    this.changeRelatedCharacters = this.props.changeRelatedCharacters;
    this.showFeaturedArea = this.props.showFeaturedArea;
    this.showComicArea = this.props.showComicArea; 
    routeRedirect();
  }  


  componentDidMount(){

    //this starts the whole thing off. Whatever character is passed into grabHero() will display
    //then grabComics() and grabCharacters() will grab the comics connected to him/her, and the characters 
    //in those comics
    getMainCharacterData('ultron',this.changeCharacter, this.showComicArea);

    //initially grab a comic for the main comic page with an axios request.
    //THEN anytime you arrive at that page, it'll be with data the 
    //app already has through a character search, since you'll be clicking on one of his/her comics
    var comicID = this.props.mappedComicPage.comicID;
    getMainComic(comicID,this.props.changeMainComic);

    var characterID = this.props.mappedCharacter.characterID
    var changeFeaturedComics = this.props.changeFeaturedComics;
    getComicListData(characterID,changeFeaturedComics,12,this.showComicArea);

    ///////get the character list data from the API using the featuredComicID in Redux
    var comicID = this.props.mappedCharacter.featuredComicID
    var changeRelatedCharacters = this.props.changeRelatedCharacters;  
    getCharacterListData(comicID,changeRelatedCharacters);
  
    getVideoListData("ultron",this.props.changeVideos,this.props.showVideos);

  }//end componentDidMount()
  

  render() {
    //set in devLiveCheck.js. This is used to manage dir structure between local and live
    //the live site has '/jarvis/' after .com. 
    const routeBase = localStorage.getItem("routeBase"); 

    return (
      <div className="App">  

        <HeaderContainer 
            //here we pass each reducer function. they will all be called from grabHero()
            changeCharacter = {this.props.changeCharacter}
            changeFeaturedComics = {this.props.changeFeaturedComics}
            changeRelatedCharacters = {this.props.changeRelatedCharacters}
            showFeaturedArea = {this.props.showFeaturedArea}
            showComicArea = {this.props.showComicArea}
            menu = {this.props.mappedMenu}
            changeCurrentPage = {this.props.changeCurrentPage}
            showCharacterPopup = {this.props.showCharacterPopup}
            pagination = {this.props.mappedPagination}
            characterInfo = {this.props.mappedCharacter}  
        />

          <Switch>
              {/*///////////Landing Home Screen///////////*/}
              <Route exact path = {routeBase + "/"} render={(props) => ( 
                <LandingPage  
                  characterInfo = {this.props.mappedCharacter}  
                  mainComicInfo = {this.props.mappedComicPage}  
                  changeMainComic = {this.props.changeMainComic }
                  changeCharactersInComic = {this.props.changeCharactersInComic}  
                  changeCharacter = {this.props.changeCharacter} 
                  showComicArea = {this.props.showComicArea} 
                  changePaginationPage = {this.props.changePaginationPage}  
                  pagination = {this.props.mappedPagination}  
                  changeCurrentPage = {this.props.changeCurrentPage}     
                /> 
              )} 
              />

              {/*///////////COMIC DETAIL PAGE///////////*/}
              <Route path = {routeBase + "/comicDetail"} render={(props) => ( 
                <ComicDetailLayout  
                  characterInfo = {this.props.mappedCharacter}  
                  mainComicInfo = {this.props.mappedComicPage}  
                  changeMainComic = {this.props.changeMainComic }
                  changeCharactersInComic = {this.props.changeCharactersInComic}  
                  changeCharacter = {this.props.changeCharacter} 
                  showComicArea = {this.props.showComicArea} 
                  changePaginationPage = {this.props.changePaginationPage}  
                  changeCurrentPage = {this.props.changeCurrentPage}     
                /> 
              )} 
              />

              {/*///////////CHARACTER DETAIL PAGE///////////*/}
              <Route path = {routeBase + "/character"} render={(props) => ( 
                <CharacterLayout  
                  changeCharacter = {this.props.changeCharacter}
                  characterInfo = {this.props.mappedCharacter} 
                  changeFeaturedComics = {this.props.changeFeaturedComics}
                  changeRelatedCharacters = {this.props.changeRelatedCharacters}
                  showFeaturedArea = {this.props.showFeaturedArea}
                  showComicArea = {this.props.showComicArea}    
                  //for changing data on the comic page
                  changeMainComic = {this.props.changeMainComic }
                  videoInfo = {this.props.mappedVideos}
                  showVideos = {this.props.showVideos}
                  changeVideos = {this.props.changeVideos}
                  changeSelectedVideo = {this.props.changeSelectedVideo}
                  changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
                  showCharacterPopup = {this.props.showCharacterPopup}
                  changeCurrentPage = {this.props.changeCurrentPage}
                /> 
              )} 
              />

              {/*///////////characterDatabase Screen///////////*/}
              <Route exact path = {routeBase + "/characterDatabase/:page"} render={(props) => ( 
                <CharacterDatabaseLayout  
                    changeCharacterDatabase = {this.props.changeCharacterDatabase}
                    characterDatabase = {this.props.mappedCharacterDatabase}
                    showCharacterDatabase = {this.props.showCharacterDatabase}
                    pagination = {this.props.mappedPagination}
                    changePaginationPage = {this.props.changePaginationPage}
                    changePaginationOffset= {this.props.changePaginationOffset}
                    changeCharacterLetter = {this.props.changeCharacterLetter}
                    changeCharacter = {this.props.changeCharacter}
                    showComicArea = {this.props.showComicArea} 
                    changeCurrentPage = {this.props.changeCurrentPage}
                /> 
              )} 
              />

              {/*///////////COMIC Database Screen///////////*/}
              <Route exact path = {routeBase + "/comicDatabase/:page"} render={(props) => ( 
                <ComicDatabaseLayout  
                    changeComicDatabase = {this.props.changeComicDatabase}
                    comicDatabase = {this.props.mappedComicDatabase}
                    showComicDatabase = {this.props.showComicDatabase}
                    pagination = {this.props.mappedPagination}
                    changeComicPaginationPage = {this.props.changeComicPaginationPage}
                    changeComicPaginationOffset= {this.props.changeComicPaginationOffset}
                    changeComicLetter = {this.props.changeComicLetter}
                    changeMainComic = {this.props.changeMainComic }
                    changeCurrentPage = {this.props.changeCurrentPage}
                /> 
              )} 
              />

              {/*///////////Videos Screen///////////*/}
              <Route exact path = {routeBase + "/videosPage"} render={(props) => ( 
                <VideosPageLayout  
                    characterInfo = {this.props.mappedCharacter}  
                    videoInfo = {this.props.mappedVideos}
                    showVideos = {this.props.showVideos}
                    changeVideos = {this.props.changeVideos}
                    changeSelectedVideo = {this.props.changeSelectedVideo}
                    changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
                    changeCurrentPage = {this.props.changeCurrentPage}
                /> 
              )} 
              />


          </Switch> 


        <FooterContainer />

        
      </div>
    );
  }
}



export default withRouter(connect(mapStateToProps,mapDispatchToProps)(App));
//export default App;



// WEBPACK FOOTER //
// ./src/components/App.js